import React from "react";
import UserEnumTable from "../../components/tables/UserEnumTable";
import { Box, Typography } from "@mui/material";

const MainCodePage: React.FC = () => {
  return (
    <Box>
      <Box
        sx={{
          mb: 4,
          position: "relative",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Typography variant="h1">Codes</Typography>
      </Box>
      <UserEnumTable />
    </Box>
  );
};

export default MainCodePage;
